import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { InstallationVoltagePluginService } from './voltage.service';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ConfirmComponent } from '../../../modal/confirm.component';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'installation-voltage-edit',
    templateUrl: './voltage-edit.component.html',
    standalone: false
})
export class InstallationVoltageEditPageComponent
  extends BaseInstallationEditPageComponent
  implements OnInit, OnDestroy
{
  plugin: any;
  editForm: UntypedFormGroup;

  private voltageToRemove: number;

  @ViewChild('voltageDeleteConfirm', { static: true }) voltageDeleteConfirm: ConfirmComponent;

  private sub = new Subscription();

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected fb: UntypedFormBuilder,
    private pluginService: InstallationVoltagePluginService
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['voltages'];
  }

  ngOnInit(): void {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService
      .updateVoltage(this.inspectionId, this.pointId, this.pluginId, model.voltages)
      .subscribe((res) => {
        this.processing = false;
        this.goToBack();
      });
  }

  public add() {
    const control = <UntypedFormArray>this.editForm.controls['voltages'];
    control.push(this.initVoltage());
  }

  public openVoltageDeleteConfirm(i: number) {
    this.voltageDeleteConfirm.open();
    this.voltageToRemove = i;
  }

  public remove(e: any) {
    const control = <UntypedFormArray>this.editForm.controls['voltages'];
    control.removeAt(this.voltageToRemove);
  }

  public openMenu() {
    this.menuModal.modalFooter = false;
    this.menuModal.modalHeader = false;
    this.menuModal.modalMessage = false;
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = this.fb.group({
      voltages: this.fb.array([])
    });

    const control = <UntypedFormArray>this.editForm.controls['voltages'];
    _.forEach(this.plugin.config.Voltages, (el) => {
      control.push(this.initVoltage(el));
    });
  }

  private initVoltage(el?: any) {
    return this.fb.group({
      dateTime: new UntypedFormControl(el?.DateTime ?? null),
      L1L2: new UntypedFormControl(el?.L1L2 ?? ''),
      L1L3: new UntypedFormControl(el?.L1L3 ?? ''),
      L2L3: new UntypedFormControl(el?.L2L3 ?? '')
    });
  }
}
